let hfCache = {};
//最大超时时间
let maxExpireDate = new Date('Fri, 31 Dec 9999 23:59:59 UTC');
//单位秒
let defaultExp = 20;
let hfSerializer = {
  serialize: function (item) {
    return (item && ((type(item) == 'string' && item) || JSON.stringify(item))) || '{}';
  },
  // fix for "illegal access" error on Android when JSON.parse is
  // passed null
  deserialize: function (data) {
    return (data && (((type(data) === 'object' || type(data) === 'array') && data) || JSON.parse(data))) || {};
  }
};

let cacheSerializer = {
  ...hfSerializer,
  serialize: function (item) {
    return JSON.stringify(item);
  }
}

function type(item) {
  return typeof item;
}

//是否是有效的时间类型
function isValidDate(date) {
  return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
}

//获取超时时间
function getExpiresDate(expires, now) {
  now = now || new Date();

  if (typeof expires === 'number') {
    expires = expires === Infinity ? maxExpireDate : new Date(now.getTime() + expires * 1000);
  } else if (typeof expires === 'string') {
    expires = new Date(expires);
  }

  if (expires && !isValidDate(expires)) {
    throw new Error($translate.instant('hfCache.expires.format.error'));
  }

  return expires;
}

//缓存项
function generateCacheItem(value, exp) {
  let item = {};
  item.currentTime = (new Date()).getTime();
  exp = exp || maxExpireDate;
  let expires = getExpiresDate(exp);
  // expiresTime
  item.expires = expires.getTime();
  item.value = value;
  return item;
}

//是否是缓存项
function isCacheItem(item) {
  if (typeof item !== 'object') {
    return false;
  }
  if (item) {
    if ('currentTime' in item && 'expires' in item && 'value' in item) {
      return true;
    }
  }
  return false;
}

// 检查缓存项是否有效
function checkCacheItemIfEffective(cacheItem) {
  let timeNow = (new Date()).getTime();
  return timeNow < cacheItem.expires;
}

function isQuotaExceeded(e) {
  let quotaExceeded = false;
  if (e) {
    if (e.code) {
      switch (e.code) {
        case 22:
          quotaExceeded = true;
          break;
        case 1014:
          // Firefox
          if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
            quotaExceeded = true;
          }
          break;
      }
    } else if (e.number === -2147024882) {
      // Internet Explorer 8
      quotaExceeded = true;
    }
  }
  return quotaExceeded;
}

function quotaExceedHandler(module, data, options, e) {
  if (options && options.force === true) {
    let deleteKeys = clearAllExpires();
    try {
      options.force = false;
      hfCache.push(key, val, options);
    } catch (err) {
    }
  }
};
//清除所有过期项
function clearAllExpires() {
  let length = localStorage.length;
  let deleteKeys = [];
  for (let i = 0; i < length; i++) {
    let key = localStorage.key(i);
    let cacheItem = null;
    try {
      cacheItem = cacheSerializer.deserialize(localStorage.getItem(key));
    } catch (e) {
    }

    if (cacheItem !== null && cacheItem.expires !== undefined) {
      let timeNow = (new Date()).getTime();
      if (timeNow >= cacheItem.expires) {
        deleteKeys.push(key);
      }
    }
  }
  deleteKeys.forEach(function (key) {
    hfCache.clear(key);
  });
  return deleteKeys;
}

/**
 *清除sessionStorage
 *@param : module模块名称
 *
 */
hfCache.clear = function (module) {
  if (!window.localStorage) {
    return;
  }
  if (!module) {
    localStorage.clear();
  }
  delete localStorage[module];
};
/**
 *
 */
hfCache.pushForMax = function (module, data) {
  hfCache.push(module, data, {
    exp: maxExpireDate
  });
}
/**
 *根据模块和url进行数据存储
 *@param : module 模块名称 data 存储数据
 *
 */
hfCache.push = function (module, data, options) {
  if (!window.localStorage) {
    return;
  }
  options = {force: true, ...options};
  if (!options.exp && defaultExp > 0) {
    options.exp = defaultExp;
  }

  if (data === undefined) {
    hfCache.clear(module);
  }

  let value = cacheSerializer.serialize(data);
  let cacheItem = generateCacheItem(value, options.exp);
  try {
    localStorage.setItem(module, cacheSerializer.serialize(cacheItem));
  } catch (e) {
    if (isQuotaExceeded(e)) {//data wasn't successfully saved due to quota exceed so throw an error
      quotaExceedHandler(module, data, options, e);
    } else {
    }
  }
};
/**
 *获取缓存数据
 *@param : module 模块名称
 *@return : null或数据
 */
hfCache.get = function (module) {
  if (!window.localStorage) {
    return null;
  }
  let cacheItem = null;
  try {
    cacheItem = cacheSerializer.deserialize(localStorage.getItem(module));
  } catch (e) {
    return null;
  }
  if (isCacheItem(cacheItem)) {
    if (checkCacheItemIfEffective(cacheItem)) {
      let value = cacheItem.value;
      return cacheSerializer.deserialize(value);
    } else {
      hfCache.clear(module);
    }
  }
  return null;
};
/**
 *获取缓存数据 封装为promise对象
 *@param : module 模块名称
 *@return : null或数据
 */
hfCache.asyncGet = function (module, func) {
  let obj = hfCache.get(module);
  let promise = new Promise((resolve, reject)=> {
    resolve({value: obj});
  });
  return obj == null ? func() : promise;
};
/**
 *缓存中是否已经存在 对应数据
 *@param : module模块
 *@return : false不存在 true存在
 */
hfCache.contains = function (module) {
  if (!window.localStorage) {
    return false;
  }
  let obj = localStorage[module];
  if (!obj) {
    return false;
  }
  return true;
};


export  default {
  serializer: hfSerializer,
  cache: hfCache
}



// WEBPACK FOOTER //
// ./src/utils/hfCache.js